export default {
  inserted (el, binding) {
    const SELECTWRAP_DOM = el.querySelector('.el-select-dropdown .el-select-dropdown__wrap')

    // 添加滚动事件监听
    SELECTWRAP_DOM.addEventListener('scroll', function () {
      // 判断是否滚动到底部（距离底部20px时触发）
      const condition = this.scrollHeight - this.scrollTop <= this.clientHeight + 20

      if (condition) {
        binding.value() // 触发加载更多
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/elSelectLoadmore.js